module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-navy.365c24ad.png";